<template>
  <v-autocomplete
    :class="{
      'advancedSearch rounded-pill fill-height': true,
      'hideResult': Array.isArray(result) && result.length > 0,
      'advancedSearchRegular': isRegular,
    }"
    :items="items"
    :placeholder="placeholder"
    return-object
    hide-details
    :dense="isDense"
    no-filter
    outlined
    @update:search-input="updateText">
    <template v-slot:item="{ item }">
      <div
        class="foreground--text fill-height d-flex align-center"
        style="width: 100%; height: 48px;"
        @click="() => setResult(item)"
        v-if="item">
        <span>
          Pesquisar por
          <span
            class="font-weight-bold"
            v-text="item.label"
          />
          para: <span v-text="text" />
        </span>
      </div>
    </template>

    <template
      v-slot:selection="{ }">
      <div
        :class="{
          'd-flex flex-nowrap fill-height overflow-auto advancedSearchScrollbar': true,
          'pl-4': Array.isArray(result) && result.length === 0
        }"
        v-if="Array.isArray(result) && result.length > 0">
        <v-row
          v-for="(search, searchIndex) in result"
          :key="search.uniqueKey"
          class="fill-height"
          no-gutters>
          <v-col
            class="fill-height d-flex flex-row align-center text-truncate elevation-3 mr-2">
            <div
              :key="`${search.key}-${search.uniqueKey}`"
              :class="`fill-height d-flex flex-row align-center ${color} foreground--text mr-2 px-4`">
              {{ getItemLabel(search.key) }}
            </div>

            <span
              :key="`${search.value}-${search.uniqueKey}-${valueIndex}`"
              class="fill-height d-flex flex-row align-center pr-2"
              v-for="(value, valueIndex) in search.value">
              {{
                !!search.value
                && search.value.length > 0
                && valueIndex < search.value.length-1
                  ? `${value} ou`
                  : value
              }}
            </span>

            <v-btn
              icon
              outlined
              small
              class="mr-2"
              @click="removeFilter(searchIndex)">
              <v-icon
                :color="color">
                close
              </v-icon>
            </v-btn>

            <v-divider
              vertical
            />
          </v-col>
        </v-row>
      </div>
    </template>

    <template v-slot:append>
      <v-icon
        :color="color">
        mdi-magnify
      </v-icon>
    </template>
  </v-autocomplete>
</template>

<script>

export default {
  name: "AdvancedSearch",

  data: () => ({
    text: null,
    filter: [],
    result: [],
  }),

  props: {
    color: {
      type: String,
      default: "primary",
    },

    placeholder: {
      type: String,
      default: "Busca de layout...",
    },

    items: {
      type: Array,
      default: () => [],
    },

    resetAdvancedSearch: {
      type: Boolean,
      default: false,
    },

    isDense: {
      type: Boolean,
      default: false,
    },

    isRegular: {
      type: Boolean,
      default: false,
    },

    isMultiple: {
      type: Boolean,
      default: true,
    },
  },

  watch: {
    resetAdvancedSearch: {
      handler(newValue) {
        if (newValue) {
          this.resetAdvancedSearchData();
        }
      },
    }
  },

  methods: {
    // Emitir resultado de pesquisa
    emitResult() {
      this.$emit('result', this.result.map((el) => ({key: el.key, value: el.value})));
    },

    // Buscar label do item selecionado
    getItemLabel(key) {
      const itemIndex = this.items.findIndex(el => el.id === key);
      return itemIndex !== -1 ? this.items[itemIndex].label : '';
    },

    // Remover Filtro selecionado
    removeFilter(filterIndex) {
      this.result.splice(filterIndex, 1);

      this.emitResult();
    },

    // Limpar variáveis do componente
    resetAdvancedSearchData() {
      this.text = null;

      this.filter = [];

      this.result = [];

      this.$emit('resetAdvancedSearch', false);

      this.emitResult();
    },

    // Adicionar Filtro selecionado
    setResult(filterField) {
      if (!filterField) return;

      if (!!this.text) {
        const uniqueKey = `${filterField.id}-${Date.now()}`;

        if (!this.result.some(el => el.key === filterField.id)) {
          this.result.push({ uniqueKey, key: filterField.id, value: [this.text] });
        } else {
          const keyIndex = this.result.findIndex(el => el.key === filterField.id);

          if (!this.result[keyIndex].value.includes(this.text)) {
            if (this.isMultiple) this.result[keyIndex].value.push(this.text);
            if (!this.isMultiple) this.result[keyIndex].value = [this.text];
          }
        }
      }

      this.text = null;

      this.emitResult();
    },

    // Atualizar texto digitado
    updateText(event) {
      this.text = event;
    },
  }
}
</script>

<style lang="scss">
.advancedSearch >
  .v-input__control >
    .v-input__slot {
  display: flex;
  flex-direction: row;
  text-overflow: ellipsis;
}

.advancedSearchRegular
  {
    height: 50px;
    max-height: 50px;

    > .v-input__control {
      box-shadow: inset 0 0 0 2px var(--v-border-base) !important;
      height: 50px;
      max-height: 50px;

      > .v-input__slot {
        min-height: 50px !important;

        > fieldset {
          border-width: 0 !important;
        }

        /* height: 50px !important; */
        /* max-height: 50px !important; */

        > .v-select__slot {
          > .v-input__append-inner {
            height: 100%;
            margin: 0 !important;
            display: flex !important;
            align-items: center !important;
          }
        }
      }
    }
}

.advancedSearch >
  .v-input__control >
    .v-input__slot {
  overflow: hidden;
}

.advancedSearch.hideResult >
  .v-input__control >
  .v-input__slot {
    padding-left: 0% !important;
}

.advancedSearch >
  .v-input__control >
    .v-input__slot >
      .v-select__slot >
        .v-select__selections {
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
  padding: 0%;
}

.advancedSearchScrollbar::-webkit-scrollbar {
  height: 6px;
}

.advancedSearchScrollbar::-webkit-scrollbar-thumb {
  background-color: var(--v-muted-base);
  border-radius: 3px;
}

.advancedSearchScrollbar::-webkit-scrollbar-track {
  background-color: transparent;
}
</style>